import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-header align-items-center bg-success border-0" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title align-items-start flex-column" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder text-light h3" }, "Pending Batch Attendance List ")
  ])
], -1)
const _hoisted_3 = {
  id: "pending_attendance",
  class: "collapse show"
}
const _hoisted_4 = { class: "collapse show" }
const _hoisted_5 = { class: "card-body border-top p-6" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-md-3" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Tranche", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = { class: "col-md-3" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Training Partner", -1)
const _hoisted_12 = { class: "col-md-3" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Training Institute", -1)
const _hoisted_14 = { class: "col-md-3" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Course", -1)
const _hoisted_16 = { class: "row mt-3" }
const _hoisted_17 = { class: "col-md-3" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Division", -1)
const _hoisted_19 = { class: "col-md-3" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "District", -1)
const _hoisted_21 = { class: "col-md-3" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Grace Period in Day", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_24 = { class: "col-md-2 mt-2" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_26 = { class: "row mt-4" }
const _hoisted_27 = { class: "col-md-6 my-auto" }
const _hoisted_28 = { class: "m-0" }
const _hoisted_29 = {
  style: {"float":"left"},
  class: "col-md-6 text-end",
  "data-v-54b12dc8": ""
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-excel fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-pdf fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "div pb-2" })
], -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "div pb-2" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_Field = _resolveComponent("Field")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _hoisted_9,
              _createVNode(_component_Multiselect, {
                modelValue: _ctx.batch.tranche_id,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.batch.tranche_id) = $event)),
                options: _ctx.optionsTranche,
                mode: "tags",
                "clear-on-select": false,
                placeholder: "Select Tranche",
                "close-on-select": false,
                searchable: true,
                "create-option": true
              }, null, 8, ["modelValue", "options"])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createVNode(_component_Multiselect, {
                modelValue: _ctx.batch.entity_id,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.batch.entity_id) = $event)),
                options: _ctx.optionsTPartner,
                mode: "tags",
                "clear-on-select": false,
                placeholder: "Select Training Partner",
                "close-on-select": false,
                searchable: true,
                "create-option": true
              }, null, 8, ["modelValue", "options"])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createVNode(_component_el_select, {
                class: "form-select-solid",
                placeholder: "Select Institute",
                modelValue: _ctx.batch.institute_id,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.batch.institute_id) = $event)),
                name: "institute_id",
                filterable: "",
                style: {"width":"100%"},
                onChange: _ctx.courseInfo
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    value: "",
                    label: "Select Training Institute"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("--Select Training Institute--")
                    ]),
                    _: 1
                  }),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.instituteList, (info) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: info.id,
                      label: info.institute_name,
                      value: info.id
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(info.institute_name), 1)
                      ]),
                      _: 2
                    }, 1032, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "onChange"])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createVNode(_component_el_select, {
                class: "form-select-solid",
                placeholder: "Select Course",
                modelValue: _ctx.batch.course_id,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.batch.course_id) = $event)),
                name: "course_id",
                filterable: "",
                style: {"width":"100%"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    value: "",
                    label: "Select Course"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("--Select Course--")
                    ]),
                    _: 1
                  }),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.courseList, (info) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: info.id,
                      label: info.course_name,
                      value: info.id
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(info.course_name), 1)
                      ]),
                      _: 2
                    }, 1032, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                _createVNode(_component_el_select, {
                  class: "form-select-solid",
                  placeholder: "Select Division",
                  modelValue: _ctx.batch.division,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.batch.division) = $event)),
                  filterable: "",
                  onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.getDistrict())),
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      value: "",
                      label: "Select Division"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("--Select Division--")
                      ]),
                      _: 1
                    }),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.division_data, (division) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: division.id,
                        label: division.division_name_eng,
                        value: division.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(division.division_name_eng), 1)
                        ]),
                        _: 2
                      }, 1032, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _hoisted_20,
                _createVNode(_component_el_select, {
                  class: "form-select-solid",
                  placeholder: "Select District",
                  modelValue: _ctx.batch.district,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.batch.district) = $event)),
                  filterable: "",
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      value: "",
                      label: "Select District"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("--Select District--")
                      ]),
                      _: 1
                    }),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.districts_data, (district) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: district.id,
                        label: district.district_name_eng,
                        value: district.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(district.district_name_eng), 1)
                        ]),
                        _: 2
                      }, 1032, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _hoisted_22,
                _hoisted_23,
                _createVNode(_component_Field, {
                  modelValue: _ctx.grace_period,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.grace_period) = $event)),
                  type: "text",
                  name: "grace_period",
                  class: "form-control form-control-sm"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("button", {
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.getpendingbatch())),
                  type: "button",
                  class: "btn btn-success mt-6 p-3",
                  style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
                }, [
                  _createTextVNode(" Search "),
                  _hoisted_25
                ])
              ])
            ])
          ]),
          (_ctx.showCourseNotice)
            ? (_openBlock(), _createElementBlock("div", {
                key: _ctx.componentkey,
                class: "card-body p-0"
              }, [
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("h4", _hoisted_28, "Pending Batch Attendance List (Total: " + _toDisplayString(_ctx.data.length) + ")", 1)
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-success btn-lg btn-icon fs-7 p-4",
                      title: "Download Xlse",
                      "data-v-54b12dc8": "",
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.exportTrainee()))
                    }, _hoisted_31),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-danger btn-lg btn-icon fs-7 ml-3 p-4",
                      title: "Download PDF",
                      "data-v-54b12dc8": "",
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.downloadPdf()))
                    }, _hoisted_33),
                    _hoisted_34,
                    _hoisted_35
                  ])
                ]),
                _createVNode(_component_Datatable, {
                  "table-data": _ctx.data,
                  "table-header": _ctx.tableHeader,
                  "enable-items-per-page-dropdown": true
                }, {
                  "cell-tranche": _withCtx(({ row: batch }) => [
                    _createTextVNode(_toDisplayString(batch?.tranche), 1)
                  ]),
                  "cell-entity": _withCtx(({ row: batch }) => [
                    _createTextVNode(_toDisplayString(batch?.entity_short_name), 1)
                  ]),
                  "cell-institute": _withCtx(({ row: batch }) => [
                    _createTextVNode(_toDisplayString(batch?.institute_name), 1)
                  ]),
                  "cell-division": _withCtx(({ row: batch }) => [
                    _createTextVNode(_toDisplayString(batch?.division), 1)
                  ]),
                  "cell-district": _withCtx(({ row: batch }) => [
                    _createTextVNode(_toDisplayString(batch?.district), 1)
                  ]),
                  "cell-upazila": _withCtx(({ row: batch }) => [
                    _createTextVNode(_toDisplayString(batch?.upazila), 1)
                  ]),
                  "cell-course": _withCtx(({ row: batch }) => [
                    _createTextVNode(_toDisplayString(batch?.course_name), 1)
                  ]),
                  "cell-batch_no": _withCtx(({ row: batch }) => [
                    _createTextVNode(_toDisplayString(batch?.batch_sequence_number), 1)
                  ]),
                  "cell-start_date": _withCtx(({ row: batch }) => [
                    _createTextVNode(_toDisplayString(batch?.start_date?_ctx.moment(batch?.start_date).format("DD-MM-YYYY"):batch?.start_date), 1)
                  ]),
                  "cell-end_date": _withCtx(({ row: batch }) => [
                    _createTextVNode(_toDisplayString(batch?.end_date?_ctx.moment(batch?.end_date).format("DD-MM-YYYY") : batch?.end_date), 1)
                  ]),
                  "cell-last_att_date": _withCtx(({ row: batch }) => [
                    _createTextVNode(_toDisplayString(batch?.last_attendance_date?_ctx.moment(batch?.last_attendance_date).format("DD-MM-YYYY") : batch?.last_attendance_date), 1)
                  ]),
                  "cell-last_att_update_time": _withCtx(({ row: batch }) => [
                    _createTextVNode(_toDisplayString(batch?.last_attendance_update_time?_ctx.moment(batch?.last_attendance_update_time).format("DD-MM-YYYY hh:mm:ss") : batch?.last_attendance_update_time), 1)
                  ]),
                  "cell-time_gap": _withCtx(({ row: batch }) => [
                    _createTextVNode(_toDisplayString(batch?.time_gap), 1)
                  ]),
                  _: 1
                }, 8, ["table-data", "table-header"])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])), [
      [_directive_loading, _ctx.loading]
    ])
  ]))
}